export default {
  GET_RESPONDENTS_SUCCESS(state, payload) {
    state.respondentList = payload
    state.errors.getRespondents = ''
  },
  GET_RESPONDENTS_ERROR(state, error) {
    state.errors.getRespondents = error
  },
  SAVE_RESPONDENT_PARAMS(state, payload) {
    const { inn, okpo } = payload
    state.respondentParams.inn = inn
    state.respondentParams.okpo = okpo
  },
  CLEAR_RESPONDENT_PARAMS(state) {
    state.respondentParams = { inn: '', okpo: '' }
  },
  SET_RESPONDENTS_TABLE_LOADING(state, payload) {
    state.loading = payload
  },
  SET_VISIBLE_REFRESH_BTN(state, payload) {
    state.isShowRefreshBtn = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/respondents/mutations.js